<script setup>
import { useAppStore } from '@/stores/App'

// Vars
const app = useAppStore()
</script>

<template>
    <v-row id="companyaddressindia" no-gutters="true" class="mt-2 d-flex flex-column">
        <v-col>{{ app.companyAddressIndia.name }}</v-col>
        <v-col>{{ app.companyAddressIndia.addressLine1 }}</v-col>
        <v-col>{{ app.companyAddressIndia.addressLine2 }}</v-col>
        <v-col>
            {{ app.companyAddressIndia.city }}, {{ app.companyAddressIndia.state }},
            {{ app.companyAddressIndia.zipcode }}
        </v-col>
        <v-col>{{ app.companyAddressIndia.country }}</v-col>
    </v-row>
</template>

<style scoped></style>
